import all from './all';

export default {
  all,
};



// WEBPACK FOOTER //
// ./src/app/services/contactType/index.js